/**
 * @generated SignedSource<<b6a2ac31c23301a15bf179c143375337>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgMobileDeviceListItem_device$data = {
  readonly lastIP: string | null;
  readonly lastIPConformsToCIDR: boolean | null;
  readonly lastUsedAtDate: {
    readonly storeFormattedDate: string;
  } | null;
  readonly name: string;
  readonly store: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store">;
  } | null;
  readonly teams: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "OrgMobileDeviceListItem_device";
};
export type OrgMobileDeviceListItem_device$key = {
  readonly " $data"?: OrgMobileDeviceListItem_device$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgMobileDeviceListItem_device">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgMobileDeviceListItem_device",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "lastUsedAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "style",
              "value": "DATE_ONLY"
            }
          ],
          "kind": "ScalarField",
          "name": "storeFormattedDate",
          "storageKey": "storeFormattedDate(style:\"DATE_ONLY\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastIP",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastIPConformsToCIDR",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SharedMobileDevice",
  "abstractKey": null
};
})();

(node as any).hash = "9f18668d633b0d45c052823f2ee6643a";

export default node;
